import React from 'react'

import { GridForIcon } from './styles'

interface OwnProps {
  children: JSX.Element | JSX.Element[]
  margin?: string
  align?:
    | 'center'
    | 'flex-end'
    | 'flex-start'
    | 'inherit'
    | 'initial'
    | 'space-around'
    | 'space-between'
    | 'space-evenly'
    | undefined
  justify?:
    | 'center'
    | 'flex-end'
    | 'flex-start'
    | 'inherit'
    | 'initial'
    | 'space-around'
    | 'space-between'
    | 'space-evenly'
    | undefined
  className?: string
}

const GridStyled = ({ children, justify, align, className, margin = '16px 0 0' }: OwnProps) => (
  <GridForIcon margin={margin} justifyContent={justify} alignItems={align} className={className}>
    {children}
  </GridForIcon>
)

export default GridStyled
